module.exports = __webpack_public_path__ + "static/img/NATHAN_BRACKEN.105ac53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NATHAN_BRACKEN.jpg
// module id = SVhL
// module chunks = 0